import React, { Fragment } from "react";

export const searchColumns = [
  "mega_cabs_booking_no",
  "cust_mobile",
  "current_trip_status_type",
  "booking_via_type",
  "car_no"
];

export const tripFilterColumns = [
  {
    name: "BOOKING #",
    value: "mega_cabs_booking_no",
    type: "text",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    value: "pick_up_date_time",
    type: "date",
    // width:"130px",
  },
  {
    name: "CUSTOMER NAME",
    value: "cust_name",
    type: "text",
    // width:"130px",
  },
  {
    name: "PHONE #",
    value: "cust_mobile",
    type: "text",
    // width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "pick_up_address",
    type: "text",
    // maxWidth:"7vw",
  },
  {
    name: (
      <span>
        <Fragment>
          DROP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "dest_address",
    type: "text",
    // maxWidth:"7vw",
  },
  {
    name: "STATUS",
    value: "current_trip_status_type",
    type: "select",
    // width:"100px",
  },
  {
    name: "DRIVER ASSIGNED",
    value: "driver_name",
    type: "text",
    // width:"120px",
  },
  {
    name: "BOOKING VIA",
    value: "booking_via_type",
    type: "select",
    // width:"120px",
  },
];

export const tripColumns = [
  {
    name: "BOOKING #",
    value: "booking_number",
    selector: (row) => row["booking_number"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    value: "pickup_time",
    selector: (row) => row["pickup_time"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "CUSTOMER NAME",
    value: "customer_name",
    selector: (row) => row["customer_name"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "PHONE #",
    value: "phone_number",
    selector: (row) => row["phone_number"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "pickup_location",
    selector: (row) => row["pickup_location"],
    sortable: true,
    center: true,
    // maxWidth:"7vw",
  },
  {
    name: (
      <span>
        <Fragment>
          DROP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "drop_location",
    selector: (row) => row["drop_location"],
    sortable: true,
    center: true,
    // maxWidth:"7vw",
  },
  {
    name: "STATUS",
    value: "status",
    selector: (row) => row["status"],
    sortable: true,
    center: true,
    // width:"100px",
  },
  {
    name: "DRIVER ASSIGNED",
    value: "driver_assigned",
    selector: (row) => row["driver_assigned"],
    sortable: true,
    center: true,
    // width:"120px",
  },
  {
    name: "CAB NUMBER",
    value: "cab_number",
    selector: (row) => row["cab_number"],
    sortable: true,
    center: true,
    // width:"120px",
  },
  {
    name: "CAR TYPE",
    value: "car_Type",
    selector: (row) => row["car_Type"],
    sortable: true,
    center: true,
    // width:"120px",
  },
  {
    name: "BOOKING VIA",
    value: "booking_via",
    selector: (row) => row["booking_via"],
    sortable: true,
    center: true,
    // width:"120px",
  },
  {
    name: "",
    selector: (row) => row["action"],
    sortable: true,
    center: true,
    width: "50px",
    // style: {
    //   backgroundColor: "white",
    //   position: "sticky",
    //   right: 0,
    //   zIndex: 0,
    //   justifyContent: "center !important"
    // },
  },
];
